import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router';

import WizardFooter from './WizardFooter';
import s from './WizardPage.module.scss';

function WizardPage({
  title,
  subTitle,
  nextLabel,
  nextUrl,
  nextDisabled,
  children,
  onNext,
  titleStyle,
  subTitleStyle,
}: any) {
  const navigate = useNavigate();
  return (
    <div>
      <header>
        <h2 style={titleStyle} className={s.title}>
          {title}
        </h2>
        <h3 style={subTitleStyle} className={s.subTitle}>
          {subTitle}
        </h3>
      </header>

      {children}

      {(onNext || nextUrl) && (
        <WizardFooter
          onNext={onNext || (() => navigate(nextUrl))}
          nextLabel={nextLabel}
          // @ts-expect-error TS(2322): Type '{ onNext: any; nextLabel: any; nextDisabled:... Remove this comment to see the full error message
          nextDisabled={nextDisabled}
        />
      )}
    </div>
  );
}

WizardPage.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  nextLabel: PropTypes.string,
  nextUrl: PropTypes.string,
  nextDisabled: PropTypes.bool,
  onNext: PropTypes.func,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.node,
};

export default WizardPage;
